import { Box } from "@mui/material";
import SessionNoteContent from "./SessionNoteContent";
import { DataGrid } from "@mui/x-data-grid";
import {
  DataGridPro,
  GridToolbar,
  GridActionsCellItem,
} from "@mui/x-data-grid-pro";
import { tokens } from "../../../theme";
import {
  useTheme,
  Autocomplete,
  TextField,
  Button,
  Typography,
} from "@mui/material";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import axios from "axios";
import SaveIcon from "@mui/icons-material/Save";
import CancelIcon from "@mui/icons-material/Cancel";
import { useState, useEffect, useRef } from "react";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { useNavigate, useLocation } from "react-router-dom";
import { Formik } from "formik";
import useMediaQuery from "@mui/material/useMediaQuery";
import {
  LoadingIndicator,
  GenerateLoadingIndicator,
} from "../../../Components/Loader";
import useSharedLink from "../../../SharedLink";
import EditIcon from "@mui/icons-material/Edit";
import DownloadIcon from "@mui/icons-material/Download";
import Delete from "@mui/icons-material/Delete";
import { useSelector } from "react-redux";
import { useSnackbar } from "../../../Providers/SnackbarProvider";
import { buttonStyle, themeStyles } from "../../../constants";
import { fetchClientData } from "../../../Redux/Actions/dataActions";
import { useDispatch } from "react-redux";
import { VisibilityOffOutlined, VisibilityRounded } from "@mui/icons-material";
import { xorDecrypt } from "../../../encrypt";
import axiosInstance from "../../../api/axiosInstance";

const ManageSessionNote = () => {
  const dispatch = useDispatch();
  const clients = useSelector((state) => state.data.clientData.data) || [];
  const [showContent, setShowContent] = useState(false);
  const [selectedRow, setSelectedRow] = useState({});
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [rowToDelete, setRowToDelete] = useState(null);

  const { openSnackbar, dismiss } = useSnackbar();
  const theme = useTheme();
  const sharedLink = useSharedLink();
  const isNonMobile = useMediaQuery("(min-width:600px)");
  const colors = tokens(theme.palette.mode);
  const navigate = useNavigate();
  const location = useLocation();
  const [rows, setRows] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const isSubmittingRef = useRef(false);

  const previousPageValues = location.state?.previouspagevalues || {};
  const productPlan = xorDecrypt(localStorage.getItem("productPlan"));
  const satus = ["Pending Review", "Draft", "Approved"];
  const procedureCodes = [];

  const [initialValues, setInitialValues] = useState({
    staffid: "",
    clientid: "",
    sessionstartdate: null,
    sessionenddate: null,
    sessionstatus: "",
    procedurecode: "",
  });

  useEffect(() => {
    if (previousPageValues.formValues) {
      setInitialValues({
        ...previousPageValues.formValues,
        sessionenddate: previousPageValues.formValues.sessionenddate
          ? dayjs(previousPageValues.formValues.sessionenddate)
          : null,
        sessionstartdate: previousPageValues.formValues.sessionstartdate
          ? dayjs(previousPageValues.formValues.sessionstartdate)
          : null,
      });
    }
  }, [previousPageValues]);

  useEffect(() => {
    dispatch(fetchClientData()); // Fetch clients if needed
  }, [dispatch]);

  const handleDownloadClick = (row) => async () => {
    const id = row.sessionId;
    const subscriberId = xorDecrypt(localStorage.getItem("subscriberId"));
    openSnackbar("Downloading...", "info");

    try {
      const res = await axiosInstance.post(
        sharedLink + "/api/generatepdf",
        {
          clientId: row.clientId,
          subscriberId: subscriberId,
          procedureCode: row.procedureCode,
          sessionDate: row.sessionDate,
        },
        {
          responseType: "blob",
          withCredentials: true,
        }
      );
      if (res.status === 200) {
        const url = window.URL.createObjectURL(new Blob([res.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "download.pdf");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        openSnackbar("Downloaded successfully.", "success");
      } else {
        openSnackbar("Failed to download.", "error");
      }
    } catch (error) {
      openSnackbar("Failed to download.", "error");
    }
  };
  const handleUpdate = (updatedSessionNote) => {
    setRows((prevRows) =>
      prevRows.map((row) =>
        row.sessionId === updatedSessionNote.sessionId
          ? updatedSessionNote
          : row
      )
    );
    openSnackbar("Session note updated successfully.", "success");
  };
  const handleContentClose = () => {
    setShowContent(false);
  };
  const handleEditClick = (row) => () => {
    setShowContent(true);
    setSelectedRow(row);
  };

  const handleDeleteClick = (row) => () => {
    setRowToDelete(row);
    setDeleteDialogOpen(true);
  };

  const handleConfirmDelete = () => {
    if (rowToDelete) {
      const id = rowToDelete.sessionId;
      const idToDelete = { id: id, procedureCode: rowToDelete.procedureCode };
      axiosInstance
        .post(sharedLink + "/api/removesessionnote", idToDelete, {
          withCredentials: true,
        })
        .then((res) => {
          if (res.status === 200) {
            setRows((prevRows) =>
              prevRows.filter((row) => row.sessionId !== id)
            );
            openSnackbar("Session note deleted successfully.", "success");
          } else {
            openSnackbar("Failed to delete session note.", "error");
          }
        })
        .catch((error) => {
          openSnackbar("Failed to delete session note.", "error");
        })
        .finally(() => {
          setDeleteDialogOpen(false);
          setRowToDelete(null);
        });
    }
  };

  const handleFormSubmit = (values) => {
    setInitialValues(values);

    const formatsessionstartdate = values.sessionstartdate
      ? dayjs(values.sessionstartdate).format("YYYY-MM-DD")
      : null;
    const formatsessionenddate = values.sessionenddate
      ? dayjs(values.sessionenddate).format("YYYY-MM-DD")
      : null;

    const startDate = dayjs(formatsessionstartdate);
    const endDate = dayjs(formatsessionenddate);
    const differenceInDays = endDate.diff(startDate, "day");

    const today = endDate.toDate();
    const sevenDaysAgo = new Date(today.setDate(today.getDate() - 7));
    const sevenDaysAgoDayjs = dayjs(sevenDaysAgo);
    const subscriberId = xorDecrypt(localStorage.getItem("subscriberId"));
    //console.log("Decrypted Subscriber ID:", subscriberId);

    if (differenceInDays < 0 || differenceInDays > 8) {
      openSnackbar(
        "The difference between start and end date must not exceed 7 days.",
        "error"
      );

      return;
    }

    let payload = {
      subscriberId: subscriberId,
      procedureCode: values.procedurecode,
      clientId: values.clientid,
    };
    if (values.sessionenddate) payload.sessionenddate = formatsessionenddate;
    if (values.sessionstartdate)
      payload.sessionstartdate = formatsessionstartdate;

    // if (values.clientid) payload.clientid = values.clientid;
    // if (values.procedurecode) payload.procedurecode = values.procedurecode;

    openSnackbar("Please wait while we are fetching data", "info");
    setIsLoading(true);

    async function sendRequest(payload) {
      //console.log("Payload:", payload);
      try {
        const res = await axiosInstance.post(
          sharedLink + "/api/viewasessionnote",
          payload,
          { withCredentials: true }
        );
        if (res.status === 200) {
          //console.log("Response:", res.data);
          if (Array.isArray(res.data) && res.data.length > 0) {
            setRows(res.data);
            dismiss();
          } else {
            setRows([]);
            openSnackbar(
              "No session notes found for the selected client or date range.",
              "info"
            );
          }
        } else {
          setRows([]);
          openSnackbar(
            "An error has occurred, Please contact Support.",
            "error"
          );
        }
      } catch (error) {
        openSnackbar(error, "error");
      } finally {
        setIsLoading(false);
      }
    }

    sendRequest(payload);
  };

  const columns = [
    { field: "clientName", headerName: "Client Name", width: 150 },
    //{ field: "clientId", headerName: "Client ID", width: 150 },
    { field: "procedureCode", headerName: "Procedure Code", width: 150 },
    { field: "sessionDate", headerName: "Session Date", width: 150 },
    { field: "sessionStartTime", headerName: "Session Start Time", width: 150 },
    { field: "sessionEndTime", headerName: "Session End Time", width: 150 },
    { field: "modifier", headerName: "Modifier", width: 100 },
    { field: "diagnosisCode1", headerName: "Diagnosis Code", width: 150 },
    {
      field: "sessionParticipants",
      headerName: "Session Participants",
      width: 200,
    },
    // { field: "status", headerName: "Status", width: 100 },

    {
      field: "actions",
      type: "actions",
      headerName: "Actions",
      width: 100,
      cellClassName: "actions",
      getActions: (params) => {
        const id = params.row.sessionId;

        return [
          <GridActionsCellItem
            key={`edit-${id}`}
            icon={<VisibilityRounded />}
            label="Edit"
            className="textPrimary"
            onClick={handleEditClick(params.row)}
            color="inherit"
          />,
          <GridActionsCellItem
            key={`delete-${id}`}
            icon={<Delete />}
            label="Delete"
            onClick={handleDeleteClick(params.row)}
            disabled={params.row.status === "Inactive"}
            color="inherit"
          />,
          <GridActionsCellItem
            key={`download-${id}`}
            icon={<DownloadIcon />}
            label="Download"
            onClick={handleDownloadClick(params.row)}
            color="inherit"
          />,
        ];
      },
    },
  ];
  const colorfulTextStyle = {
    background: "linear-gradient(45deg, #ffa500, #ffffff, #ffa500)",
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
    fontWeight: "bold",
    marginBottom: "30px",
    marginTop: "20px",
  };
  const productPlans = {
    LDBasic: "LDBasic",
    LDPremium: "LDPremium",
    HDBasic: "HDBasic",
    HDPremium: "HDPremium",
  };
  const customProcedureCodes = [
    {
      id: "97151",
      code: "97151",
    },
    {
      id: "97153",
      code: "97153",
    },
    {
      id: "97155",
      code: "97155",
    },
    {
      id: "97156",
      code: "97156",
    },
  ];
  const filteredProcedureCodes =
    productPlan === 'RBT Basic Plan' ||
    productPlan === 'RBT Plus Plan' ||
    productPlan === 'RBT Premium Plan'
      ? customProcedureCodes.filter((code) => code.id === "97153")
      : customProcedureCodes;
  const mergedProcedureCodes = [
    ...customProcedureCodes,
    ...(procedureCodes || []),
  ];

  if (isLoading) {
    return <LoadingIndicator />;
  } else {
    return (
      <div>
        <Box
          sx={{
            m: "0 auto", // Center horizontally
            p: "10px", // Padding for spacing
            width: "95%", // Fit to screen width
            maxWidth: "1200px", // Limit width for large screens
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Typography variant="h4" gutterBottom sx={colorfulTextStyle}>
            Session Notes:
          </Typography>

          <Formik onSubmit={handleFormSubmit} initialValues={initialValues}>
            {({
              values,
              errors,
              touched,
              handleBlur,
              handleChange,
              handleSubmit,
              setFieldValue,
            }) => (
              <form onSubmit={handleSubmit}>
                <Box
                  display="grid"
                  gap="30px"
                  gridTemplateColumns="repeat(4, minmax(0, 1fr))"
                  sx={{
                    "& > div": {
                      gridColumn: isNonMobile ? undefined : "span 4",
                    },
                  }}
                >
                  <Autocomplete
                    fullWidth
                    options={filteredProcedureCodes}
                    getOptionLabel={(option) => `${option.code}`}
                    value={
                      filteredProcedureCodes.find(
                        (code) => code.id === values.procedurecode
                      ) || null
                    }
                    autoHighlight
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Procedure Code"
                        variant="outlined"
                        className="animated-input"
                        inputProps={{
                          ...params.inputProps,
                          "aria-label": "Select Procedure Code",
                        }}
                        sx={themeStyles.textField}
                      />
                    )}
                    name="procedurecode"
                    onChange={(event, newValue) =>
                      setFieldValue(
                        "procedurecode",
                        newValue ? newValue.id : ""
                      )
                    }
                  />
                  <Autocomplete
                    fullWidth
                    options={clients || []}
                    getOptionLabel={(option) => `${option.clientName} `}
                    value={
                      (clients || []).find(
                        (client) => client.id === values.clientid
                      ) || null
                    }
                    autoHighlight
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Client Name"
                        variant="outlined"
                        className="animated-input"
                        inputProps={{
                          ...params.inputProps,
                          "aria-label": "Select Client Name",
                        }}
                        sx={themeStyles.textField}
                      />
                    )}
                    name="clientid"
                    onChange={(event, newValue) =>
                      setFieldValue("clientid", newValue ? newValue.id : "")
                    }
                  />
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      fullWidth
                      type="date"
                      label="Start Date"
                      name="sessionstartdate"
                      value={values.sessionstartdate}
                      onChange={(value) => {
                        setFieldValue("sessionstartdate", value);
                        if (value) {
                          const today = dayjs();
                          const endDate = dayjs(value).add(7, "day");
                          const finalEndDate = endDate.isAfter(today)
                            ? today
                            : endDate;

                          setFieldValue("sessionenddate", finalEndDate);
                        }
                      }}
                      shouldDisableDate={(date) => date.isAfter(dayjs())}
                      InputLabelProps={{ shrink: true }}
                      variant="filled"
                      className="animated-input"
                      sx={themeStyles.textField}
                    />
                    <DatePicker
                      fullWidth
                      type="date"
                      label="End Date"
                      name="sessionenddate"
                      value={values.sessionenddate}
                      onChange={(value) =>
                        setFieldValue("sessionenddate", value)
                      }
                      InputLabelProps={{ shrink: true }}
                      variant="filled"
                      className="animated-input"
                      shouldDisableDate={(date) => date.isAfter(dayjs())}
                      sx={themeStyles.textField}
                    />
                  </LocalizationProvider>
                </Box>
                <Box display="flex" justifyContent="flex-end" mt={"10px"}>
                  <Button
                    type="submit"
                    color="secondary"
                    variant="contained"
                    sx={{ ...buttonStyle }}
                  >
                    Submit
                  </Button>
                </Box>
              </form>
            )}
          </Formik>
          <Box
            sx={{
              m: "20px",
              width: "100%",
              height: "400px",
            }}
          >
            <Box
              sx={{
                height: "400px",
                "& .MuiDataGrid-root": {
                  border: "none",
                },
                "& .MuiDataGrid-columnHeaders": {
                  color: "white",
                  backgroundColor: "#1c1c1c", // Darker background color for header
                  borderBottom: "2px solid #e9a132", // Header border
                },
                "& .MuiDataGrid-footerContainer": {
                  color: "white",
                  backgroundColor: "#1c1c1c", // Darker background color for footer
                  borderTop: "2px solid #e9a132", // Footer border
                },
                "& .MuiDataGrid-cell": {
                  color: "white",
                  borderBottom: "1px solid #e9a132", // Cell border
                },
                "& .MuiDataGrid-columnSeparator": {
                  color: "white", // Separator color (optional visibility)
                },
                "& .MuiDataGrid-sortIcon": {
                  color: "white", // Sorting arrows
                },
                "& .MuiDataGrid-iconSeparator": {
                  color: "white", // Separator icon color
                  "&:hover": {
                    color: "white", // Separator icon hover color
                  },
                },
                "& .MuiSvgIcon-root": {
                  color: "white", // All icons
                },
                "& .MuiTablePagination-root": {
                  color: "white", // Pagination text
                },
                "& .MuiTablePagination-actions": {
                  color: "white", // Pagination arrows
                },
                "& .MuiInputBase-root": {
                  color: "white", // Input text (e.g., rows per page)
                },
                "& .MuiSelect-icon": {
                  color: "white", // Dropdown arrow
                },
                // Custom scrollbar styles
                "& .MuiDataGrid-virtualScroller": {
                  backgroundColor: "#000", // Dark background for scroller
                  "&::-webkit-scrollbar": {
                    width: "8px", // Width of the scrollbar
                    height: "8px", // Height of the scrollbar
                  },
                  "&::-webkit-scrollbar-thumb": {
                    backgroundColor: "#e9a132", // Scrollbar thumb color (orange)
                    borderRadius: "8px", // Rounded corners for the scrollbar thumb
                  },
                  "&::-webkit-scrollbar-thumb:hover": {
                    backgroundColor: "#d0892f", // Darken the thumb on hover
                  },
                  "&::-webkit-scrollbar-track": {
                    backgroundColor: "#333", // Scrollbar track color
                    borderRadius: "8px", // Rounded corners for the scrollbar track
                  },
                },
              }}
            >
              <DataGrid
                sx={{
                  boxShadow: 5,
                  border: 5,
                  borderColor: "#e9a132", // Border color
                  "& .MuiDataGrid-cell:hover": {
                    color: "#e9a132", // Hover effect on cells
                  },
                  "& .MuiDataGrid-columnHeaderTitle": {
                    color: "white !important",
                    fontWeight: "bold !important",
                  },
                }}
                pagination
                initialState={{
                  pagination: {
                    paginationModel: {
                      pageSize: 25,
                    },
                  },
                  columns: {
                    columnVisibilityModel: {
                      sessionId: false,
                      lastUpdatedBy: false,
                      lastUpdatedTime: false,
                      enteredTime: false,
                      enteredBy: false,
                    },
                  },
                }}
                rows={rows}
                columns={columns}
                getRowId={(row) => row.sessionId}
                components={{ Toolbar: GridToolbar }}
                onRowDoubleClick={(params) => {
                  handleEditClick(params.row)();
                }}
              />
              <Dialog
                open={deleteDialogOpen}
                onClose={() => setDeleteDialogOpen(false)}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                PaperProps={{
                  sx: {
                    backgroundColor: "#333",
                    color: "white",
                  },
                }}
              >
                <DialogTitle id="alert-dialog-title">
                  {"Confirm Delete"}
                </DialogTitle>
                <DialogContent>
                  <DialogContentText id="alert-dialog-description" sx={{ color: "white" }}>
                    Are you sure you want to delete this session note?
                  </DialogContentText>
                </DialogContent>
                <DialogActions>
                  <Button
                    onClick={() => setDeleteDialogOpen(false)}
                    
                    sx={{
                      color: "white",
                      "&:hover": { backgroundColor: "#444" },
                    }}
                   
                   
                  >
                    Cancel
                  </Button>
                  <Button
                    onClick={handleConfirmDelete}
                    
                    sx={{
                      color: "white",
                      backgroundColor: "#e9a132",
                      "&:hover": { backgroundColor: "#d0892f" },
                    }}
                    
                    autoFocus
                  >
                    Confirm
                  </Button>
                </DialogActions>
              </Dialog>
            </Box>
          </Box>
        </Box>
        {showContent && (
          <SessionNoteContent
            clients={clients}
            open={showContent}
            selectedRow={selectedRow}
            handleClose={handleContentClose}
            onUpdate={handleUpdate}
          />
        )}
      </div>
    );
  }
};

const formatDate = (date) => {
  if (!date) return "";
  const d = new Date(date);
  return d.toISOString().split("T")[0];
};

const dateTimeFormatter = (value, locale = "en-US") => {
  if (!value) return "";

  const date = new Date(value);
  const year = date.getFullYear();
  const month = date.getMonth() + 1;
  const day = date.getDate();
  const formattedDate = `${year}-${month.toString().padStart(2, "0")}-${day
    .toString()
    .padStart(2, "0")}`;

  const timeFormatter = new Intl.DateTimeFormat(locale, {
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: true,
  });

  const formattedTime = timeFormatter.format(date);

  return `${formattedDate} ${formattedTime}`;
};

export default ManageSessionNote;
